// extracted by mini-css-extract-plugin
export default {"container":"PrivateContainer_container__bvKij","move-right":"PrivateContainer_move-right__WTYU+","wrapper":"PrivateContainer_wrapper__lOyMl"};